import { render } from "./financialStats-2024.vue?vue&type=template&id=59b99650&scoped=true"
import script from "./financialStats-2024.vue?vue&type=script&lang=js"
export * from "./financialStats-2024.vue?vue&type=script&lang=js"

import "./financialStats-2024.vue?vue&type=style&index=0&id=59b99650&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b99650"]])

export default __exports__